module.exports = {
  init() {
    this.scrollShow();
    this.cookie();
  },

  scrollShow() {
    $(window).scroll(function () {
      if (
        $(window).scrollTop() >
        $(".home-banner").innerHeight() / 2 -
          $(".home-banner img").height() / 2 +
          120
      ) {
        $("header .navbar-brand").addClass("show");
      } else {
        $("header .navbar-brand").removeClass("show");
      }
      if ($(window).scrollTop() > 0 && !$("header").hasClass("show")) {
        $("header").addClass("show");
      } else if ($(window).scrollTop() == 0) {
        $("header").removeClass("show");
      }
      if (
        $(window).scrollTop() + $(window).height() >
        $(".contact-form").offset().top
      ) {
        $(".grecaptcha-badge").addClass("show");
      } else {
        $(".grecaptcha-badge").removeClass("show");
      }
    });
  },

  cookie() {
    $(document).ready(function () {
      $.cookieBar({
        message:
          "This website uses cookies to ensure you get the best experience on our website. For more information visit our <a href='/cookies-policy'>Cookies Policy</a>.",
        acceptText: "I'm happy with that",
        fixed: true,
        policyButton: false,
        policyText: "Find out more",
        policyURL: "/cookies-policy",
      });
    });
  },
};
